module.exports = __webpack_public_path__ + "img/vk.7feb7abf.svg";